import { Switch as MainSwitch } from '@/components/widgets/switch'
import { css } from 'styled-system/css'


export const Switch = (props: {
	active: boolean,
	onClick?: () => void;
}) => {
	return (
		<div className={css({
			'& .switch': {
				bgColor: 'jupiter.grey.50',
				_active: {
					bgColor: 'jupiter.main.primary'
				}
			},
			'& .switch__thumb': {
				bgColor: 'jupiter.grey.10',
			},
            
		})}
		>
			<MainSwitch {...props} />
		</div>
	)
}